import { IFormValidation } from '@aston/foundation';

export class IUpdateSubsidiaryValidator implements IFormValidation {
	ruleset = 'updateSubsidiaryCommandValidator';
	fields = {
		AnnualFigure: 'AnnualFigure',
		Name: 'Name',
		Street: 'PhysicalAddress.Street',
		ZipCode: 'PhysicalAddress.ZipCode',
		City: 'PhysicalAddress.City',
		Country: 'PhysicalAddress.CountryCode',
		CurrencyCode: 'CurrencyCode',
	};
}

export const UpdateSubsidiaryValidator = new IUpdateSubsidiaryValidator();
